var map = {
	"./browse-category-1.jpg": 2293,
	"./browse-category-2.jpg": 1429,
	"./browse-category-3.jpg": 7591,
	"./browse-category-4.jpg": 469,
	"./browse-category-5.jpg": 9261,
	"./browse-category-6.jpg": 7854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7170;